import SubViewOptions from '../SubViewOptions';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import AttendanceRequestedTableApp from './Functionality/AttendanceRequestedTableApp';
import CustomTable from "../../../../../../components/table/CustomTable";
import React from "react";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {Trans} from "react-i18next";
import {CloseIcon, InfoChip} from "../../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../../../../Apis/functions";
import {PERIOD_TIME_UNIT_ENUM} from "../../../../../../enums/PeriodTimeUnitEnum";
import CancelModal from "../../../../Dining/Schedules/Modal/CancelModal";
import {handleOnClick} from "./Model/Model";
import {getInfoParagraphByStatus} from "../../../../ApprovalTracker/Model/Model";
/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack
 * @Email : kpozos@ibl.mx
 *
 */
const AttendanceRequestedTable = ({
    subView,
    option,
    changeSubViewManage,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    selectedList,
    setSelectedList,
    modified,
    setModified
}) => {
    const {
        t,
        dispatch,
        navigate,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        genericCommentModals,
        getAttendancePeriodRequest,
        row
    } = AttendanceRequestedTableApp({
        selectedList,
        setSelectedList,
        searchElement,
        modified,
        setModified,
        setBodyForExport,
        option
    });

    return (
        <>
            <div className='d-flex'>
                <SubViewOptions subView={subView} changeSubViewManage={changeSubViewManage} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>

            { getAttendancePeriodRequest && tbody?.data?.length > 0 &&
                <div className={"row mb-3"}>
                    <CustomUserChip
                        className="chip-secondary-150-100 p-0 justify-content-start"
                        name={
                            <Trans
                                i18nKey="period_type_from_to"
                                values={{
                                    periodType:
                                        `${getAttendancePeriodRequest?.frequencyValueSnapshot} ${t(PERIOD_TIME_UNIT_ENUM[getAttendancePeriodRequest?.frequencyTimeUnitSnapshot]?.trans)}`,
                                    from: getDateFormat(getAttendancePeriodRequest?.startDate, true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
                                    to: getDateFormat(getAttendancePeriodRequest?.endDate, true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
                                }}
                                components={{ span: <span className='px-3' /> }}
                            />
                        }
                        Icon={InfoChip}
                        showAvatar={true}
                        variant="large"
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon="icon-color-secondary-700"
                        deleteIcon={<CloseIcon className={`font-color-secondary-700 h-18px`} />}
                    />
                </div>
            }

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                selectedList={selectedList}
                textNotInformation={getAttendancePeriodRequest ? "no_attendance_requests_to_review_available" : "there_not_period_active" }
            />
            {pagination()}

            {genericCommentModals.map(({
                                           show,
                                           setter,
                                           title,
                                           status,
                                           requiredComment
                                       }) => {
                return (
                    <>
                        <CancelModal
                            show={show}
                            onHide={() => setter(false)}
                            onConfirm={(e, comment) => {
                                handleOnClick(dispatch, navigate, row?.id, comment, status, setModified);
                            }}
                            requiredComment={requiredComment}
                            title_modal={title}
                            description={t("are_you_sure_to_proceed")}
                            subDescription={t(getInfoParagraphByStatus(status))}
                        />
                    </>
                );
            })}
        </>
    );
};

export default AttendanceRequestedTable;
